import Vue from 'vue';

export default Vue.extend({
  props: {
    /**
     * Sets the DOM id on the component
     */
    id: {
      type: String,
      required: false
    },
  },
  data: () => {
    const randomId = Math.floor(Math.random() * Date.now()).toString(16);
    return ({
      cgId: `cg-${randomId}`,
    });
  },
  computed: {
    elementId (): string {
      const { id, cgId } = this;
      return id || cgId;
    },
  },
});